import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export function Eyebrow({ children, center = false, className = "" }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 14 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.4 }}
      transition={{ duration: 0.8, ease: EASE }}
      className={`flex items-center gap-4 ${center ? "justify-center" : ""} ${className}`}
    >
      <span className="h-px w-10 bg-gold/70" aria-hidden="true" />
      <span className="text-[11px] font-semibold uppercase tracking-[0.3em] text-gold sm:text-xs">
        {children}
      </span>
      {center && <span className="h-px w-10 bg-gold/70" aria-hidden="true" />}
    </motion.div>
  );
}

export function FadeIn({ children, delay = 0, y = 28, className = "" }) {
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.9, delay, ease: EASE }}
      className={className}
    >
      {children}
    </motion.div>
  );
}

export function MaskedLine({ children, delay = 0, inView = false, className = "" }) {
  const inner = (
    <motion.span
      className="block will-change-transform"
      initial={{ y: "112%" }}
      {...(inView
        ? { whileInView: { y: 0 }, viewport: { once: true, amount: 0.4 } }
        : { animate: { y: 0 } })}
      transition={{ duration: 1.1, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  );
  return <span className={`block overflow-hidden pb-[0.1em] -mb-[0.1em] ${className}`}>{inner}</span>;
}

export function LogoMark({ className = "h-11 w-11" }) {
  return (
    <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
      <rect width="64" height="64" rx="12" fill="#0d1b2e" />
      <circle cx="32" cy="32" r="22" fill="none" stroke="#c9a45c" strokeWidth="2" />
      <path
        d="M17 36.5c3.75-4 7.5-4 11.25 0s7.5 4 11.25 0 5.25-3.4 7.5-1.2"
        fill="none"
        stroke="#c9a45c"
        strokeWidth="2.4"
        strokeLinecap="round"
      />
      <path
        d="M17 43.5c3.75-4 7.5-4 11.25 0s7.5 4 11.25 0"
        fill="none"
        stroke="#c9a45c"
        strokeWidth="2.4"
        strokeLinecap="round"
        opacity="0.6"
      />
      <path d="M32 13.5l2.6 6.4-2.6 5.9-2.6-5.9z" fill="#c9a45c" />
      <path d="M32 13.5v12.3" stroke="#0d1b2e" strokeWidth="0.9" />
    </svg>
  );
}

export function GoldButton({ children, href, className = "", testId, onClick }) {
  const cls = `inline-flex items-center justify-center bg-gold px-9 py-4 text-[12px] font-semibold uppercase tracking-[0.24em] text-navy-800 transition-colors duration-300 hover:bg-gold-light ${className}`;
  if (onClick) {
    return (
      <button onClick={onClick} data-testid={testId} className={cls}>
        {children}
      </button>
    );
  }
  return (
    <a href={href} data-testid={testId} className={cls}>
      {children}
    </a>
  );
}

export function OutlineButton({ children, href, className = "", testId }) {
  return (
    <a
      href={href}
      data-testid={testId}
      className={`inline-flex items-center justify-center border border-gold/70 px-9 py-4 text-[12px] font-semibold uppercase tracking-[0.24em] text-gold transition-colors duration-300 hover:bg-gold-muted ${className}`}
    >
      {children}
    </a>
  );
}
